import { Injectable } from '@angular/core'
import { FormArray, FormControl, FormGroup, Validators,ValidatorFn,AbstractControl,ValidationErrors } from '@angular/forms'
import * as _ from 'lodash'
import { AtylTable } from './atyl-input-components/atyl-input-components'
import { FormAtylBase } from './form-atyl-base'
import { FormAtylRestriction } from './form-atyl-restriction'


export function RadioUndefinedValidator(message:string): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        const value = control.value;

        
        let undef="undefined"
		let undefo= {
			radio:"undefined"	
			}
		//console.log("RadioUndefinedValidator",value,undef,undefo,message)
		
		let bl:boolean= (value==null || value=='' 
			|| 
			value==undef || JSON.stringify(value)==JSON.stringify(undefo));	 

        return bl ? { 
        		required:true}: null;
    }
}

@Injectable()
export class FormAtylControlService {

	toFormGroup(atylInputs: FormAtylBase<any>[]) {
		let group: any = {}

		atylInputs.forEach((atylInput) => {
			if (atylInput != undefined && atylInput.mendatory
			
			) {
				if (atylInput.controlType == 'radio') {
				//console.log("FormAtylControlService toFormGroup",atylInput)
					let restriction:any=new FormAtylRestriction({
									type: 'radio_undefined',	
									messageError: 'Le champs est requis.',
					});
					atylInput.restrictions.push(restriction);
				}
				else {
					atylInput.restrictions.push(
						new FormAtylRestriction({
							type: 'required',
							messageError: 'Le champs est requis.',
						})
					)
				}
				
				
			}
			if (atylInput && atylInput.controlType == 'checkbox') {
				
				
				let vll:any[]=[];
				
				/*if (atylInput.value) {
					vll=atylInput.value;
				} else {
					if (atylInput.options!=undefined
					&& atylInput.options.value!=undefined
					)
					vll=atylInput.options.value;
					
				}*/
			//	console.log("FormAtylControlService toFormGroup checkbox",atylInput,vll);
				group[atylInput.ID] =
					atylInput.restrictions != []
						? new FormArray(
						vll,
							this.getValidators(atylInput.restrictions)
						)
						: new FormArray([])
			} else if (atylInput && atylInput.controlType == 'daterange') {
				group[atylInput.ID] =
					atylInput.restrictions != []
						? new FormArray(
							[],
							this.getValidators(atylInput.restrictions)
						)
						: new FormArray([])
				atylInput.options.forEach((option, i) => {
					(group[atylInput.ID] as FormArray).push(
						new FormControl(atylInput.value === option.value || '')
					)
				})
			} else if (atylInput && atylInput.controlType == 'table') {
				group[atylInput.ID] =
					atylInput.restrictions != []
						? new FormArray(
							[],
							this.getValidators(atylInput.restrictions)
						)
						: new FormArray([])
				let table = atylInput as AtylTable
				if (table.rows && table.rows.length > 0) {
					table.rows.forEach((row, index) => {
						table.rowControlers.push(
							this.generateControlersTable(
								row,
								table.value ? table.value[index] : null
							)
						)
					})
				}
				table.rowControlers.forEach((rowControler, index) => {
					(group[atylInput.ID] as FormArray).push(
						rowControler as FormGroup
					)
				})
			} else if (atylInput && atylInput.controlType == 'adresse') {
				console.log(atylInput, 'adresse', atylInput.controlType)
				group[atylInput.ID] = new FormGroup({})
				_.forEach(atylInput.options, (option, i) => {
					let disabled = true
					let restrictions = [new FormAtylRestriction()]
					if (i.toString().indexOf('code') != -1) {
						disabled = false
					} else if (i.toString().indexOf('ville') != -1) {
						disabled = false
						if (atylInput.mendatory) {
							restrictions = [
								new FormAtylRestriction({
									type: 'required',
									messageError: 'Le champs est requis.',
								}),
							]
						}
					}
					group[atylInput.ID].addControl(
						i,
						new FormControl(
							{
								value:
									atylInput.value &&
										atylInput.value[i] === option.value
										? option.value
										: '',
								disabled: disabled,
							},
							this.getValidators(restrictions)
						)
					)
				})
			} else if(atylInput && atylInput.controlType == "place"){
			        group[atylInput.ID] = new FormGroup({});
			        _.forEach(atylInput.options, (option, i) => 
			        {
			            let disabled = false;
			            let restrictions = [new FormAtylRestriction()];
			            
			            if(i.toString().indexOf("geotype") != -1
						&&	atylInput.mendatory){
			                  restrictions = [new FormAtylRestriction({
			                    "type":"required",
			                    "messageError":"Le champs est requis."
			                  })]
			             }
			             
			          
			            group[atylInput.ID].addControl(i,new FormControl({value : (atylInput.value && atylInput.value[i] === option.value) ? option.value : '', disabled: disabled}, this.getValidators(restrictions)));
			        }); 
			 }
			 else if (atylInput && atylInput.controlType == 'selectionlist') {
				group[atylInput.ID] =
					atylInput.restrictions != []
						? new FormControl(
							atylInput.value || '',
							this.getValidators(atylInput.restrictions)
						)
						: new FormControl(atylInput.value || '')
			} else if (atylInput && atylInput.controlType == 'radio') {
				group[atylInput.ID] = new FormGroup({})
				if (atylInput.restrictions.length>0)
					group[atylInput.ID].setValidators(this.getValidators(atylInput.restrictions));
				group[atylInput.ID].addControl(
					'radio',
					atylInput.restrictions.length>0
						? new FormControl(
							atylInput.value || ''
								? String(atylInput.value.radio)
								: String(atylInput.optionsDefault.value)
								/*,
							this.getValidators(atylInput.restrictions)*/
							
						)
						: new FormControl(
							atylInput.value || ''
								? String(atylInput.value.radio)
								: String(atylInput.optionsDefault.value)
						)
				)
				if (atylInput.complementary) {
					group[atylInput.ID].controls['comp'] =
						atylInput.restrictions != []
							? new FormControl(
								atylInput.value || '',
								this.getValidators(atylInput.restrictions)
								
							)
							: new FormControl(atylInput.value || '')
				}
			} else if (atylInput && atylInput.controlType == 'agrement') {
				group[atylInput.ID] = new FormControl([])
			} else if (atylInput && atylInput.controlType == 'dropdown2') {
				let defaultValue = ''
				if (atylInput.optionsDefault) {
					atylInput.optionsDefault.forEach((element) => {
						if (element.default && element.default === true) {
							defaultValue = element.key
						}
					})
				}
				var vl = '' + defaultValue
				if (atylInput.value !== undefined) vl = '' + atylInput.value

				group[atylInput.ID] =
					atylInput.restrictions != []
						? new FormControl(
							vl,
							this.getValidators(atylInput.restrictions)
						)
						: new FormControl(vl)
			} else if (atylInput) {
				group[atylInput.ID] =
					atylInput.restrictions != []
						? new FormControl(
							atylInput.value || '',
							this.getValidators(atylInput.restrictions)
						)
						: new FormControl(atylInput.value || '')
			}
			group[atylInput.ID].observe_champ = atylInput.observe_champ;
		})
		return new FormGroup(group)
	}

	generateControlersTable(inputsTable: FormAtylBase<any>[], tableData?: any) {
		let formGroup: any = {}
		let keys = Object.getOwnPropertyNames(inputsTable)

		keys.forEach((key, index) => {
			if (
				inputsTable[key].controler &&
				inputsTable[key].controler.controlType == 'checkbox'
			) {
				formGroup[inputsTable[key].controler.ID] =
					inputsTable[key].controler.restrictions != []
						? new FormArray(
							[],
							this.getValidators(
								inputsTable[key].controler.restrictions
							)
						)
						: new FormArray([])
				inputsTable[key].controler.options.values.forEach(
					(option, i) => {
						if (
							Array.isArray(inputsTable[key].controler.value) &&
							inputsTable[key].controler.value.length > 0
						) {
							inputsTable[key].controler.value.forEach(
								(element, index) => {
									if (option.value === index)
										(
											formGroup[
											inputsTable[key].controler.ID
											] as FormArray
										).insert(
											option.value,
											new FormControl(element)
										)
								}
							)
						} else {
							(
								formGroup[
								inputsTable[key].controler.ID
								] as FormArray
							).insert(
								option.value,
								new FormControl(
									inputsTable[key].controler.value || false
								)
							)
						}
					}
				)
			} else if (
				inputsTable[key].controler &&
				inputsTable[key].controler.controlType == 'daterange'
			) {
				formGroup[inputsTable[key].controler.ID] =
					inputsTable[key].controler.restrictions != []
						? new FormArray(
							[],
							this.getValidators(
								inputsTable[key].controler.restrictions
							)
						)
						: new FormArray([])
				inputsTable[key].controler.options.forEach((option, i) => {
					(
						formGroup[inputsTable[key].controler.ID] as FormArray
					).push(
						new FormControl(
							inputsTable[key].controler.value === option.value ||
							''
						)
					)
				})
			} else if (
				inputsTable[key].controler &&
				inputsTable[key].controler.controlType == 'radio'
			) {
				formGroup[inputsTable[key].controler.ID] = new FormGroup({})
				if (tableData) {
					if (
						tableData[inputsTable[key].controler.ID] &&
						!tableData[inputsTable[key].controler.ID].radio
					)
						formGroup[inputsTable[key].controler.ID].addControl(
							'radio',
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									tableData[
									inputsTable[key].controler.ID
									] || '',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl(
									tableData[
									inputsTable[key].controler.ID
									] || ''
								)
						)
					else if (
						tableData[inputsTable[key].controler.ID] &&
						tableData[inputsTable[key].controler.ID].radio
					)
						formGroup[inputsTable[key].controler.ID].addControl(
							'radio',
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									tableData[inputsTable[key].controler.ID]
										.radio || '',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl(
									tableData[inputsTable[key].controler.ID]
										.radio || ''
								)
						)
					else if (tableData[inputsTable[key].controler.ID] == '')
						formGroup[inputsTable[key].controler.ID].addControl(
							'radio',
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									'',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl('')
						)
					else if (
						tableData[
						key.split('_')[0] +
						'_' +
						inputsTable[key].controler.ID
						] &&
						!tableData[
							key.split('_')[0] +
							'_' +
							inputsTable[key].controler.ID
						].radio
					)
						formGroup[inputsTable[key].controler.ID].addControl(
							'radio',
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									tableData[
									key.split('_')[0] +
									'_' +
									inputsTable[key].controler.ID
									] || '',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl(
									tableData[
									key.split('_')[0] +
									'_' +
									inputsTable[key].controler.ID
									] || ''
								)
						)
					else if (
						tableData[
						key.split('_')[0] +
						'_' +
						inputsTable[key].controler.ID
						] &&
						tableData[
							key.split('_')[0] +
							'_' +
							inputsTable[key].controler.ID
						].radio
					)
						formGroup[inputsTable[key].controler.ID].addControl(
							'radio',
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									tableData[
										key.split('_')[0] +
										'_' +
										inputsTable[key].controler.ID
									].radio || '',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl(
									tableData[
										key.split('_')[0] +
										'_' +
										inputsTable[key].controler.ID
									].radio || ''
								)
						)
					else if (
						tableData[
						key.split('_')[0] +
						'_' +
						inputsTable[key].controler.ID
						] == ''
					)
						formGroup[inputsTable[key].controler.ID].addControl(
							'radio',
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									'',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl('')
						)
				} else {
					formGroup[inputsTable[key].controler.ID].addControl(
						'radio',
						inputsTable[key].controler.restrictions != []
							? new FormControl(
								'',
								this.getValidators(
									inputsTable[key].controler.restrictions
								)
							)
							: new FormControl('')
					)
				}
			} else if (inputsTable[key].controler) {
				if (tableData) {
					if (
						tableData[
						key.split('_')[0] +
						'_' +
						inputsTable[key].controler.ID
						]
					)
						formGroup[inputsTable[key].controler.ID] =
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									tableData[
									key.split('_')[0] +
									'_' +
									inputsTable[key].controler.ID
									] || '',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl(
									tableData[
									key.split('_')[0] +
									'_' +
									inputsTable[key].controler.ID
									] || ''
								)
					else
						formGroup[inputsTable[key].controler.ID] =
							inputsTable[key].controler.restrictions != []
								? new FormControl(
									tableData[
									inputsTable[key].controler.ID
									] || '',
									this.getValidators(
										inputsTable[key].controler
											.restrictions
									)
								)
								: new FormControl(
									tableData[
									inputsTable[key].controler.ID
									] || ''
								)
				} else
					formGroup[inputsTable[key].controler.ID] =
						inputsTable[key].controler.restrictions != []
							? new FormControl(
								'',
								this.getValidators(
									inputsTable[key].controler.restrictions
								)
							)
							: new FormControl('')
			}
		})

		return new FormGroup(formGroup)
	}

	getValidators(restrictions: FormAtylRestriction<any>[]) {
		const listValidators: any[] = []
		const listRestrictions: FormAtylRestriction<any>[] = restrictions
		listRestrictions.forEach((restrict, index) => {
			switch (restrict.type) {
				case 'required': {
					const valid = Validators.required
					listValidators.push(valid)
					break
				}
				case 'radio_undefined': {
					const valid = RadioUndefinedValidator(restrict.messageError)
					listValidators.push(valid)
					break;
				}
				case 'pattern': {
					if (restrict.value != '') {
						const valid = Validators.pattern(restrict.value)
						listValidators.push(valid)
					}
					break
				}
				case 'min': {
					if (restrict.value != '') {
						const valid = Validators.min(Number(restrict.value))
						listValidators.push(valid)
					}
					break
				}
				case 'max': {
					if (restrict.value != '') {
						const valid = Validators.max(Number(restrict.value))
						listValidators.push(valid)
					}
					break
				}
				case 'maxlength': {
					if (restrict.value != '') {
						const valid = Validators.maxLength(
							Number(restrict.value)
						)
						listValidators.push(valid)
					}
					break
				}
			}
		})

		return listValidators
	}
	isNumber(n) {
		return /^-?[\d.]+(?:e-?\d+)?$/.test(n)
	}
}
